import { Stack } from "@mui/material";

import { type ShiftBoardShiftLogs, type ShiftBoardWorkplace } from "../types";
import { ShiftBoardLiveTracker } from "./LiveTracker/LiveTracker";
import { ShiftBoardShiftHistory } from "./ShiftHistory";

export function ShiftBoardShiftCardDetails({
  logs,
  workplace,
}: {
  logs: ShiftBoardShiftLogs[];
  workplace: ShiftBoardWorkplace;
}) {
  return (
    <Stack spacing={2}>
      <ShiftBoardLiveTracker />
      <ShiftBoardShiftHistory workplace={workplace} logs={logs} />
    </Stack>
  );
}
